import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStatus, useStoreBrnDSSelector, useStoreSelector } from '../store/selectors/userSelector';
import { URLS } from '.';

const PublicRoutes = () => {
    const isAuth = useAuthStatus();
    const storeInfo = useStoreSelector();
    const branchInfo = useStoreBrnDSSelector();
    // console.log('~~~~~~~~~PUBLIC~~~~~~~~~~~~~~~', {isAuth, storeInfo, branchInfo})
    if (!isAuth) {
        return <Outlet />;
    }

    if (isAuth && storeInfo?.store_id && branchInfo?.branch_id && branchInfo?.ds_id) {
        return <Navigate to={URLS.DASHBOARD} />;
    }

    if (isAuth && !storeInfo?.store_id && !branchInfo?.branch_id && !branchInfo?.ds_id) {
        return <Navigate to={URLS.STORE.CREATE} />;
    }

    if (isAuth && storeInfo?.store_id && !branchInfo?.branch_id && !branchInfo?.ds_id) {
        return <Navigate to={URLS.STORE.BRANCHES} />;
    }

    if (isAuth && storeInfo?.store_id && branchInfo?.branch_id && !branchInfo?.ds_id) {
        return <Navigate to={URLS.DATASOURCES.CREATE} />;
    }

    return <Outlet />;
    // return (
    //     isAuth ? <Navigate to={URLS.DASHBOARD} /> : <Outlet /> 
    // )
}

export default PublicRoutes;